import React, { type MouseEventHandler } from 'react';
import Box from '@mui/material/Box';
import { AdForm } from 'organisms';
import type { AdFormValues } from 'organisms/AdForm/AdForm';
import type { FormikHelpers } from 'formik';
import { PageHeader } from 'molecules';
import useStyles from './styles';

/**
 * Campaign step 1: campaign details (name, type, assets, click-through URL).
 * Loads campaign types via AdForm data wrapper.
 */
const CampaignInfoStep = (props: CampaignInfoStepProps) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.stepRoot} data-component="CampaignInfoStep">
      <Box className={classes.stepMain}>
        <PageHeader
          title="Ad Campaign"
          description="Ad campaigns fill all available ad space. Campaign creative is subject to approval."
          divider
        />
        <Box className={classes.stepFormFill}>
          <AdForm {...props} stickyActionsFooter />
        </Box>
      </Box>
    </Box>
  );
};

export type CampaignInfoStepProps = {
  campaign: AdFormValues;
  handleSubmit: (values: AdFormValues, helpers: FormikHelpers<AdFormValues>) => void;
  handleBackClick: MouseEventHandler;
  totalCost: number;
  updateTotalCost: (campaignCost: number) => void;
};

export default CampaignInfoStep;
